export default (function (theme) {
  return {
    container: {
      position: 'relative'
    },
    suggestionsContainerOpen: {
      width: '100%',
      position: 'absolute',
      zIndex: 1,
      marginTop: '-3px',
      minWidth: '7em'
    },
    suggestion: {
      display: 'block'
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none'
    },
    autocompleteBold: {
      fontWeight: 'bold',
      backgroundColor: 'transparent!important'
    },
    loader: {
      marginTop: 0
    },
    autoSuggestContainer: {
      position: 'relative'
    },
    autoSuggestClearButton: {
      position: 'absolute',
      right: '5px',
      bottom: '11px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    clearIcon: {
      width: '.8em',
      height: '.8em'
    },
    autoSuggestInput: {
      width: '85%'
    }
  };
});